export function SidePattern({ isReversed = false }: { isReversed?: boolean }) {
  return (
    <div className="relative hidden h-full p-10 lg:block">
      <div
        className={`base-grid absolute inset-0 opacity-50 ${isReversed ? "-scale-x-100" : ""}`}
      />
      <div
        className={`absolute top-0 h-full w-20 bg-linear-to-l ${
          isReversed
            ? "to-background left-0 from-transparent"
            : "from-background right-0 to-transparent"
        }`}
      />
    </div>
  );
}
